import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Badge } from "../ui/badge";
import { TestSubsection } from "./TestSection";
import { Shield, Users, Package, Anchor, Calendar, GitBranch } from "lucide-react";
import * as tests from "./testDefinitions";

export const OperationsSection = ({ testResults }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg font-semibold">🏢 Operations</CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        <TestSubsection
          icon={Shield}
          iconColor="text-blue-600"
          title="Roles"
          tests={tests.rolesTests}
          results={testResults.roles}
        />
        
        <TestSubsection
          icon={Users}
          iconColor="text-green-600"
          title="Team"
          tests={tests.teamTests}
          results={testResults.team}
        />
        
        <TestSubsection
          icon={Package}
          iconColor="text-orange-600"
          title="Assets"
          tests={tests.assetsTests}
          results={testResults.assets}
        />
        
        <TestSubsection
          icon={Anchor}
          iconColor="text-cyan-600"
          title="Services"
          tests={tests.servicesTests}
          results={testResults.services}
        />
        
        <TestSubsection
          icon={Calendar}
          iconColor="text-purple-600"
          title="Bookings"
          badge={<Badge className="bg-orange-500 text-white text-xs">New</Badge>}
          tests={tests.bookingsTests}
          results={testResults.bookings}
        />
        
        <TestSubsection
          icon={GitBranch}
          iconColor="text-indigo-600"
          title="Flows"
          badge={<Badge className="bg-orange-500 text-white text-xs">New</Badge>}
          tests={tests.flowsTests}
          results={testResults.flows}
        />
      </CardContent>
    </Card>
  );
};
